//a set of icons used with the rating dropdown for client to select from
//they are in a shape that is ready to be fed directly into a SingleSelect option component
const RATING_ICONS = [
  { text: 'Star', value: 'iconRatingStar' },
  { text: 'Heart', value: 'iconRatingHeart' },
  { text: 'Chessknight', value: 'iconRatingChessknight' },
  { text: 'Cloud', value: 'iconRatingCloud' },
  { text: 'Flag', value: 'iconRatingFlag' },
  { text: 'Futbol', value: 'iconRatingFutbol' },
  { text: 'Gem', value: 'iconRatingGem' },
  { text: 'Headphones', value: 'iconRatingHeadphones' },
  { text: 'House', value: 'iconRatingHouse' },
  { text: 'Lemon', value: 'iconRatingLemon' },
  { text: 'Lightbulb', value: 'iconRatingLightbulb' },
  { text: 'Moon', value: 'iconRatingMoon' },
  { text: 'Snowflake', value: 'iconRatingSnowflake' },
  { text: 'Thumbsup', value: 'iconRatingThumbsup' },
  { text: 'Truck', value: 'iconRatingTruck' },
];

export default RATING_ICONS;
